// extracted by mini-css-extract-plugin
export default {"header":"Header_header__IYKkH","burger":"Header_burger__RuKsW","title":"Header_title__ZeKN2","logo":"Header_logo__CXeU3","burger-active":"Header_burger-active__8uVwU"};